import AivoryLogo from "../../assets/img/projects/aivory.png";
import FundusAiLogo from "../../assets/img/projects/fundusai.png";
import FutureFishLogo from "../../assets/img/projects/futurefish.svg";
import NafiamLogo from "../../assets/img/projects/nafiam.jpg";
import EmrilAcademyLogo from "../../assets/img/projects/emrilacademy.png";
import ManysubsLogo from "../../assets/img/projects/manysubs.png";

import LogoTextWhite from "../../assets/img/logo/logo-white-text.svg";

export {
  AivoryLogo,
  FundusAiLogo,
  FutureFishLogo,
  NafiamLogo,
  EmrilAcademyLogo,
  ManysubsLogo,
};
export const Logos = {
  LogoTextWhite,
};

export const AppDomain = "theajstars.co";
export const ContactInformation = {
  email: "me@theajstars.co",
};
export const HttpSuccessCodesObj = {
  Success: 200,
  Created: 201,
  Accepted: 202,
  NoContent: 204,
};

export const HttpErrorCodesObj = {
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  Conflict: 409,
  InternalServerError: 500,
  UnprocessableEntity: 422,
  Expired: 410,
  PaymentFailed: 402,
};

export const VerseDuration = 20; // 8 seconds per verse
